import styled from "styled-components";

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 23px 276px;

  @keyframes smoothScroll {
    0% {
      opacity: 0;
    }
    25% {
      opacity: 0.3;
    }
    50% {
      opacity: 0.8;
    }
    100% {
      opacity: 1;
    }
  }

  ${({fixHeader}) => fixHeader && 'height: 80px;'}
  

  @media (max-width: 1440px) {
    padding: 23px 96px;
  }

  @media (max-width: 1024px) {
    padding: 10px 24px;
    ${({fixHeader}) => fixHeader && 'height: 64px;'}
    svg {
      height: 28px;
      width: 140px;
    }
  }

  @media (max-width: 600px) {
    ${({isMobileMenuOpen}) => isMobileMenuOpen && 'background: #ffffff;'}
    ${({fixHeader}) => fixHeader && 'height: 42px;'}
    padding: 12px;
    svg {
      width: 110px;
      height: 22px;
    }
  }
`;

export const HeaderBtnContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  column-gap: 10px;

  @media (max-width: 600px) {
    position: absolute;
    width: 100%;
    z-index: 10;

    // animation: menuDrop 2s forwards;

    padding-top: 48px;
    padding-bottom: 32px;

    background: #ffffff;
    box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.12);
    border-radius: 0px 0px 24px 24px;

    flex-direction: column;
    justify-content: unset;
    align-items: center
    column-gap: 0;
    row-gap: 32px;

    // @keyframes menuDrop {
    //   0% {
    //     transform: translateY(-428px);
    //   }
    //   100% {
    //     transform: translateY(0px);
    //   }
    // }
  }
`;

export const MobileMenu = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  svg {
    width: 12px;
    height: 10px;
    
    ${({fixHeader}) => fixHeader && 'path {fill: black !important;}'}
  }

  p {
    margin-left: 4px;
    font-style: normal;
    font-weight: 800;
    font-size: 13px;
    line-height: 110%;
    letter-spacing: -0.04em;
    color: ${({fixHeader, isMobileMenuOpen}) => (fixHeader || isMobileMenuOpen) ? '#222224' : '#FFFFFF'};
  }
`;

export const PrimaryButton = styled.button`
  padding: 16px 24px;
  border: ${({showBorder}) => showBorder ? '2px solid' : 'none'};
  border-color: ${({fixHeader}) => fixHeader ? '#222224' : '#FFFFFF'};
  border-radius: 58px;

  font-family: Inter;
  font-style: normal;
  font-weight: 800;
  font-size: 20px;
  line-height: 110%;

  text-align: center;

  color: ${({fixHeader}) => fixHeader ? '#222224' : '#FFFFFF'};
  background: transparent;

  @media (max-width: 1024px) {
    padding: 14px 24px;
    font-size: 16px;
    line-height: 18px;
  }

  @media (max-width: 600px) {
    padding: 8px 24px;

    font-size: 28px;
    line-height: 120%;

    color: #222224;
    border-color: #222224;
  }

  :hover {
    background: rgba(255, 255, 255, 0.1);
  }
`;